import React, { Component } from 'react'
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'

import axios from 'axios'
import Base from './Config'
import WaveLoading from 'react-loadingg/lib/WaveLoading';

import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

class Items extends Component {

    edit=()=>{
        // console.log('Edit ',this.props.data);
        this.props.Edit(this.props.data)
    }

    delete=()=>{
        // console.log('delete ',this.props.data);
        this.props.Delete(this.props.data)
    }

    render() {
        // console.log('props ',this.props.data);
        const data = this.props.data
        return (
            <tr>
                <th scope="row">{data.name}</th>
                <td>{data.ar_name}</td>
                {/* <td>{data.price}</td> */}
                <td>
                <button className="btn-sm btn-outline-primary" onClick={this.edit}>
                <i className="fas fa-edit " ></i>
                </button>
                <span>&nbsp;</span>
                <button className="btn-sm btn-outline-danger" onClick={this.delete}>
                <i className="fas fa-trash"></i>
                </button>
                </td>
            </tr>
        );
    }
}
export default class Priority extends Component {

    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,
            loading:true,

            name:'',
            price:'',
            arname:'',
            id:'',

            edit:false,
        }
    }

    edit=(data)=>{
        NotificationManager.info("Please make changes in edit section","Info",3000)

        this.setState({
            edit:true,
            name:data.name,
            price:data.price,
            arname:data.ar_name,
            id:data.id
        })
        // console.log('Edit parent data ',data);
    }
    clearData=()=>{

        this.setState({
            edit:false,
            name:"",
            price:"",
            arname:"",
            id:""
        })
        // console.log('Edit parent data ',data);
    }

    deletePriority = (data)=>{
        // console.log('Delete parent data ',data.id);
        
        axios.delete(
            Base.url + 'Priority/?id='+data.id,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)
                    this.loading(false)

                }
        })
        .catch(error=>{
            NotificationManager.error('Error : ', error, 3000)

        })
    }
    

    loading=(args)=>{
        this.setState({
            loading:args
        })
    }
    componentDidMount(){
        this.fetchAllData()
    }

    next=()=>{
        this.loading(true)
        axios.get(
          this.state.next.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false, 

          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    prev=()=>{
        this.loading(true)
        axios.get(
          this.state.prev.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchAllData(){
        this.loading(true)
        axios.get(
            Base.url + 'Priority/',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading:false,
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    AddPriority=()=>{
        this.loading(true)
        // console.log('Priority/');
        // console.log(this.state)

                
        var bodyFormData = new FormData();
        bodyFormData.set('name', this.state.name);
        bodyFormData.set('price', 0.0);
        bodyFormData.set('ar_name', this.arname);

        axios.post(
            Base.url + 'Priority/',
            bodyFormData,
        {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)
                    this.clearData()
                    
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.loading(false)

                }
        })
        .catch(error=>{
            console.log(error);
            NotificationManager.error('Error : ', error, 3000)

        })
    }

    EditPriority=()=>{
        this.loading(true)
        // console.log('Priority/');
        // console.log(this.state)
                
        var bodyFormData = new FormData();
        bodyFormData.set('priority_id ', this.state.id);
        bodyFormData.set('name', this.state.name);
        bodyFormData.set('price', 0.0);
        bodyFormData.set('ar_name', this.state.arname);

        axios.put(
            Base.url + 'Priority/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)
                    this.clearData()
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.loading(false)

                }
        })
        .catch(error=>{
            console.log(error);
        })
    }

    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        })
    }
    clearEdit=()=>{
        this.setState({
            edit:false,
            name:'',
            price:'',
            arname:'',
            id:'',

        })
    }


    render() {
        return (
            <div>
{/* <NotificationContainer/> */}

                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Priority" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        <div className="row">
                            <div className="col-xl-8 mb-5 mb-xl-0">
                                <div className="card shadow">
                                    <div className="card-header border-0">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h3 className="mb-0">Priority</h3>
                                            </div>
                                            <div className="col text-right">
                                            {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                        {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.loading?<WaveLoading/>:
                                    <div className="table-responsive">
                                        {/* Projects table */}
                                        
                                        <table className="table align-items-center table-flush">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">priority</th>
                                                    <th scope="col">arabic Name</th>
                                                    {/* <th scope="col">price</th> */}
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                this.state.data.map((data,index)=>
                                                    <Items 
                                                        data={data} 
                                                        key={index} 
                                                        Edit={this.edit}
                                                        Delete={this.deletePriority}
                                                    />
                                                )
                                                }
                                               
                                            </tbody>
                                        </table>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card shadow">
                                    <div className="card-header bg-transparent">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h2 className="mb-0" />
                                                {this.state.edit?
                                                <h2><i class="fas text-red fa-window-close pr-4" onClick={this.clearEdit}></i>Edit Priority</h2>
                                                :
                                                <h2>Add Priority</h2>
                                                }
                                                
                                            </div>
                                        </div>
                                        <form role="form">
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" placeholder="Name" name="name" value={this.state.name} onChange={this.onChange} type="text" />
                                                </div>
                                            </div>
                                            {/* <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" placeholder="Price" name="price" value={this.state.price} onChange={this.onChange} type="text" />
                                                </div>
                                            </div> */}
                                            <div className="text-center text-muted mb-4">
                                                {/* <small>Or sign up with credentials</small> */}
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" placeholder="arabic name" name="arname" value={this.state.arname} onChange={this.onChange} type="email" />
                                                </div>
                                            </div>
                                        </form>
                                        <div className="text-center">
                                            {this.state.edit?
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.EditPriority}>Save</button>
                                            :
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.AddPriority}>Add</button>
                                            }
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        )
    }
}
